<template lang='pug' src='./header.pug'></template>

<script>
import Icon from 'components/icon/icon'

export default {
  computed: {
    props () {
      return this.$store.state.app['header']
    }
  },
  components: {
    Icon
  },
  methods: {
    contactLocation0 () {
      this.$router.push('/contact')
      setTimeout(() => { this.$scrollTo('#location0') }, 500)
    },
    contactLocation2 () {
      this.$router.push('/contact')
      setTimeout(() => { this.$scrollTo('#location2') }, 500)
    },
    contactLocation3 () {
      this.$router.push('/contact')
      setTimeout(() => { this.$scrollTo('#location3') }, 500)
    },
    contactLocation4 () {
      this.$router.push('/contact')
      setTimeout(() => { this.$scrollTo('#location4') }, 500)
    },
    aboutsection1 () {
      this.$router.push('/about-us')
      setTimeout(() => { this.$scrollTo('#singledoc0') }, 500)
    },
    aboutsection2 () {
      this.$router.push('/about-us')
      setTimeout(() => { this.$scrollTo('#singledoc1') }, 500)
    },
    aboutsection3 () {
      this.$router.push('/about-us')
      setTimeout(() => { this.$scrollTo('#our-promise') }, 500)
    },
    aboutsection4 () {
      this.$router.push('/about-us')
      setTimeout(() => { this.$scrollTo('#technology-and-research') }, 500)
    },
    aboutsection5 () {
      this.$router.push('/about-us')
      setTimeout(() => { this.$scrollTo('#what-sets-us-apart') }, 500)
    },
    newpatientsection1 () {
      this.$router.push('/new-patients')
      setTimeout(() => { this.$scrollTo('#newpatient0') }, 500)
    },
    newpatientsection2 () {
      this.$router.push('/new-patients')
      setTimeout(() => { this.$scrollTo('#newpatient1') }, 500)
    },
    newpatientsection3 () {
      this.$router.push('/new-patients')
      setTimeout(() => { this.$scrollTo('#newpatient2') }, 500)
    },
    newpatientsection4 () {
      this.$router.push('/new-patients')
      setTimeout(() => { this.$scrollTo('#newpatient3') }, 500)
    },
    newpatientsection5 () {
      this.$router.push('/new-patients')
      setTimeout(() => { this.$scrollTo('#newpatient4') }, 500)
    },
    ourpatientsection1 () {
      this.$router.push('/our-patient-is-you')
      setTimeout(() => { this.$scrollTo('#smile-gallery') }, 500)
    },
    ourpatientsection2 () {
      this.$router.push('/our-patient-is-you')
      setTimeout(() => { this.$scrollTo('#care0') }, 500)
    },
    ourpatientsection3 () {
      this.$router.push('/our-patient-is-you')
      setTimeout(() => { this.$scrollTo('#care1') }, 500)
    },
    ourpatientsection4 () {
      this.$router.push('/our-patient-is-you')
      setTimeout(() => { this.$scrollTo('#care2') }, 500)
    },
    ourpatientsection5 () {
      this.$router.push('/our-patient-is-you')
      setTimeout(() => { this.$scrollTo('#patient-video') }, 500)
    }
  }
}
</script>



// WEBPACK FOOTER //
// header.vue?d9878d1e